import { gql } from "@apollo/client";

export const ADD_LOCATION = gql`
mutation MyMutation($WidgetId: Int = 0, $Url: String = "", $Text: String = "") {
  insert_msgbox_WidgetLocations(objects: {Text: $Text, Url: $Url, WidgetId: $WidgetId}) {
    affected_rows
  }
}`;

